import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import TwoColumnWithImageAndRating from "components/testimonials/TwoColumnWithImageAndRating";
import { ContentWithPaddingXl } from "components/misc/Layouts";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
// To use NavBar
import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink as PrimaryLinkBase,
} from "components/headers/light.js";
import logo from "images/logo.png";
import logoImageSrc from "images/logo.png";

const NavLink = tw.a`mt-4 lg:mt-0 transition duration-300 font-medium pb-1 border-b-2 mr-12 text-gray-700 border-gray-400 hocus:border-gray-700`;
const PrimaryNavLink = tw(
  NavLink
)`text-gray-100 bg-blue-500 px-6 py-3 border-none rounded hocus:bg-blue-900 focus:shadow-outline mt-6 md:mt-4 lg:mt-0`;
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Row = tw.div`flex`;

const NavRow = tw(Row)`flex flex-col lg:flex-row items-center justify-between`;

export default () => {
  const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8 bg-blue-900`;
  const NavLink = tw(
    NavLinkBase
  )`lg:text-gray-100 lg:hocus:text-gray-300 lg:hocus:border-gray-100`;
  const LogoLink = tw(LogoLinkBase)`text-gray-100 hocus:text-gray-300`;
  const PrimaryLink = tw(
    PrimaryLinkBase
  )`shadow-raised lg:bg-blue-400 lg:hocus:bg-blue-500`;

  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/components/innerPages/AboutUsPage">About Us</NavLink>
      <NavLink href="/components/innerPages/ProjectsPage">Projects</NavLink>
      <NavLink href="/components/innerPages/BlogIndexPage">Services</NavLink>
      <PrimaryLink href="/components/innerPages/ContactUsPage">
        Get A Quote
      </PrimaryLink>
    </NavLinks>,
  ];

  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Great Wave Digital
    </LogoLink>
  );
  return (
    <>
      <ContentWithPaddingXl></ContentWithPaddingXl>
      <AnimationRevealPage>
        <MainFeature1
          subheading={<Subheading>Non-profit organization</Subheading>}
          heading="Healing As One"
          buttonRounded={false}
          primaryButtonText="Go To Site"
          primaryButtonUrl="https://healingasone.ca/"
          description="Healing as One was our first client. We designed and developed their website while also helping them with various marketing campaigns."
          imageSrc="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        />
        <MainFeature1
          subheading={<Subheading>Movie production</Subheading>}
          heading="Black Rhodes Productions"
          buttonRounded={false}
          description="Black Rhodes Productions is a movie production company that requested us to build their site while also optimixing their SEO."
          primaryButtonText="Go To Site"
          primaryButtonUrl="https://blackrhodesproductionsinc.com/"
          imageSrc="https://images.unsplash.com/3/doctype-hi-res.jpg?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80"
          textOnLeft={false}
        />
        <TwoColumnWithImageAndRating />
      </AnimationRevealPage>
    </>
  );
};
